/**
 * External Dependencies
 */
import 'jquery';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
// import Flickity from 'flickity';
// import 'flickity-imagesloaded';
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay'
import 'lity';

import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);

window.Alpine = Alpine
Alpine.plugin(collapse)
 
Alpine.start()


$(() => {

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => emblaApi.scrollPrev()
    const scrollNext = () => emblaApi.scrollNext()
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)
  
    return () => {
      prevBtn.removeEventListener('click', scrollPrev, false)
      nextBtn.removeEventListener('click', scrollNext, false)
    }
  }

  const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
      else prevBtn.setAttribute('disabled', 'disabled')
  
      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
      else nextBtn.setAttribute('disabled', 'disabled')
    }
  
    emblaApi
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  
    return () => {
      prevBtn.removeAttribute('disabled')
      nextBtn.setAttribute('disabled', 'disabled')
    }
  }

  const rootNode = document.querySelector('.home-carousel')
  const viewportNode = rootNode.querySelector('.embla-viewport')

  const prevBtn = rootNode.querySelector('.embla__prev')
  const nextBtn = rootNode.querySelector('.embla__next')

  const options = { 
    align: 'start',
    containScroll: true,
    loop: true,
  }

  const embla = EmblaCarousel(viewportNode, options, [Autoplay()])

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    embla,
    prevBtn,
    nextBtn,
  )
  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    embla,
    prevBtn,
    nextBtn,
  )

  embla
  .on('destroy', removePrevNextBtnsClickHandlers)
  .on('destroy', removeTogglePrevNextBtnsActive)


  const quoteNode = document.querySelector('.quote-carousel')
  const quoteView = quoteNode.querySelector('.quote-viewport')

  const prevQuoteBtn = quoteNode.querySelector('.embla__prev')
  const nextQuoteBtn = quoteNode.querySelector('.embla__next')

  const quoteOptions = { 
    loop: false,
    align: 'start',
    containScroll: true,
  }

  const emblaQuote = EmblaCarousel(quoteView, quoteOptions)

  const removeClickHandlers = addPrevNextBtnsClickHandlers(
    emblaQuote,
    prevQuoteBtn,
    nextQuoteBtn,
  )
  const removeBtnsActive = addTogglePrevNextBtnsActive(
    emblaQuote,
    prevQuoteBtn,
    nextQuoteBtn,
  )

  embla
  .on('destroy', removeClickHandlers)
  .on('destroy', removeBtnsActive)
 
});
